<template>
	<div class="card">
		<div class="card-header">
			<h4 class="mb-0">รายการถอนเงิน <small>(รายชั่วโมง)</small></h4>
		</div>
		<div class="card-body">
			<bar-chart
				:height="250"
				:chart-data="amountChart.chartData"
				:extra-options="amountChart.extraOptions"
			/>

			<bar-chart
				:height="250"
				class="mt-5"
				:chart-data="countChart.chartData"
				:extra-options="countChart.extraOptions"
			/>
		</div>
	</div>
</template>

<script>
import BarChart from '../../components/Charts/BarChart'

import { Charts } from '../../components/Charts/config'

export default {
	props: ['data'],
	components: {
		BarChart,
	},
	data() {
		return {
			amountChart: {
				chartData: {},
				extraOptions: {
					responsive: true,
				},
			},
			countChart: {
				chartData: {},
				extraOptions: {
					responsive: true,
				},
			},
		}
	},
	methods: {
		updateChart(v) {
			this.amountChart.chartData = {
				labels: [
					'00:00',
					'01:00',
					'02:00',
					'03:00',
					'04:00',
					'05:00',
					'06:00',
					'07:00',
					'08:00',
					'09:00',
					'10:00',
					'11:00',
					'12:00',
					'13:00',
					'14:00',
					'15:00',
					'16:00',
					'17:00',
					'18:00',
					'19:00',
					'20:00',
					'21:00',
					'22:00',
					'23:00',
				],
				datasets: [
					{
						label: 'จำนวนเงิน',
						backgroundColor: Charts.colors.theme['success'],
						data: Object.values(v.amountHours),
					},
				],
			}

			this.countChart.chartData = {
				labels: [
					'00:00',
					'01:00',
					'02:00',
					'03:00',
					'04:00',
					'05:00',
					'06:00',
					'07:00',
					'08:00',
					'09:00',
					'10:00',
					'11:00',
					'12:00',
					'13:00',
					'14:00',
					'15:00',
					'16:00',
					'17:00',
					'18:00',
					'19:00',
					'20:00',
					'21:00',
					'22:00',
					'23:00',
				],
				datasets: [
					{
						label: 'จำนวนครั้ง',
						backgroundColor: Charts.colors.theme['warning'],
						data: Object.values(v.countHours),
					},
				],
			}
		},
	},
	created() {
		this.updateChart(this.data)
	},
	watch: {
		data(v) {
			this.updateChart(v)
		},
	},
}
</script>
